import { Chip } from '@/shared/ui/chip'

// Видимость встречи заказчику сотрудник читает явно, в обоих состояниях:
// отсутствие пометки значило бы и «скрыта», и «признак не приехал». Заказчику
// пометка не показывается вовсе — ему видно только то, что открыто.
export function MeetingVisibilityChip({ visible }: { visible: boolean }) {
  return (
    <Chip tone={visible ? 'success' : 'neutral'} variant="soft">
      {visible ? 'видно заказчику' : 'скрыта от заказчика'}
    </Chip>
  )
}
